import { CodeSystem } from "context/elasticsearch/types";
import { useStoreContext } from "context/StoreProvider";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

type StateSyncProps = {
  codeSystem: CodeSystem;
};

const StateSync = ({ codeSystem }: StateSyncProps) => {
  const { codeValue } = useParams<{ codeValue: string }>();
  const { actions } = useStoreContext();
  const { updateCodeValue, updateCodeSystem, updateExcludedSearchFields } =
    actions;

  useEffect(() => {
    updateCodeValue(codeValue);
  }, [codeValue, updateCodeValue]);

  // updateCodevalue is used to keep a history, which also uses the codeSystem from global state.
  // This is the highest level where we have the codeSystem prop, so we set it here.
  useEffect(() => {
    // Remove any excluded search fields when switching code system
    updateExcludedSearchFields([]);
    updateCodeSystem(codeSystem as string);
  }, [codeSystem, updateCodeSystem, updateExcludedSearchFields]);

  return null; // Renders nothing
};

export default StateSync;
